import React, { Component } from 'react'

class InstagramPost extends Component {
    render() {
        const { link } = this.props

        return (
            <div className="instagram-post-container" style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <blockquote
                    class="instagram-media"
                    data-instgrm-permalink={link}
                    data-instgrm-version="14"
                    style={{ width: '100%' }}
                >
                </blockquote>
            </div>
        )
    }
}

export default InstagramPost
